// eslint-disable-next-line import/prefer-default-export
export const invoiceStatus = {
  2: '开发票并签章成功',
  20: '未开具',
  21: '提交服务器开票成功',
  22: '提交服务器开票失败',
  24: '签章失败',
  25: '已红冲',
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@sditest/electronic-invoice-api/src/utils/mapState.js
// module id = j6Wz
// module chunks = 70